module.exports = __webpack_public_path__ + "static/media/york-14.846ec0ed.jpg";